import React, { useState, useEffect } from 'react';
import { toInteger } from 'lodash';

import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { GiHandTruck } from "react-icons/gi";

import Page from 'src/components/Page';
import agm from '../../services/agm'

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';

import Results from './Results';
import Toolbar from './Toolbar';
import Create from './Create';
import Request from './Request';
import Ajustment from './Ajustment';
import Transfer from './Transfer';
import Balance from './Balance';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItem = {
  id: -1,
  ordem: '',
  data: null,
  anotacao: '',
  fase: 1,
  idProduto: '',
  codigoProduto: '',
  nomeProduto: '',
  custoProduto: '',
  valorMaterial: '',
  valorInstalacao: '',
  estoque: null,
  produto: null,
  qtd: 0,
  idEstoque: null,
  qtdProduto: null,
  qtdDestino: 0,
  idEstoqueDestino: null,
  qtdProdutoDestino: null
}

const defaultDependencies = {
  loaded: false,
  items: [],
  removes: [],
  stocks: [],
  categories: [],
  technicians: []
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
  { name: 'Código', field: 'item.codigo', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 1, wrap: 0 },
  { name: 'Tipo', field: '(item.tipo) ? item.tipo.nome : "Não Informado"', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Categoria', field: '(item.aplicacao) ? item.aplicacao.nome : "Não Informado"', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Valor Custo', field: 'formatDecimal(item.custo, "0.00")', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Valor Material', field: 'formatDecimal(item.valor, "0.00")', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Valor Instalação', field: 'formatDecimal(item.instalacao, "0.00")', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Estoque', field: 'formatDecimal(item.estoque, "0.0")', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Unidade', field: '(item.unidadeProduto) ? item.unidadeProduto.nome : "???"', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Último Lançamento', field: '(item.atualizacao) ? formatDatetime(item.atualizacao): "-"', size: -1, sortable: 0, exportable: 0, wrap: 0 },
];

const lancamentosResultColumns = [
  { name: 'Ordem', field: 'item.ordem', size: -1, sortable: 'ordem', exportable: 1, wrap: 0 },
  { name: 'Anotação', field: 'item.anotacao', size: -1, sortable: 'anotacao', exportable: 1, wrap: 0 },
  { name: 'Data', field: 'formatDatetime(item.data)', size: -1, sortable: 'data', exportable: 1, wrap: 0 },
  { name: 'Produtos', field: 'item.produtos', size: -1, sortable: 0, exportable: 0, wrap: 0 },
  { name: 'Status', field: 'item.fase == 1 ? "Aberto" : "Baixado"', size: -1, sortable: 'fase', exportable: 1, wrap: 0 }
];

const defaultEmptyMessage = "Nenhum Produto Foi Encontrado.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_ENABLED,
  export: LEVEL_ACCESS_ENABLED,
  view: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_ENABLED,
  export: LEVEL_ACCESS_ENABLED,
  view: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const lancamentosfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_HIDE,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  view: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: lancamentosResultColumns
};

const lancamentosCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_HIDE,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  view: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: lancamentosResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];
const lancamentosResultModes = [lancamentosfullMode, lancamentosCompactMode];

const defaultVisions = [
  { id: 2, name: 'Estoque Atual de Produtos pelo nome ', refine: 2, label: 'Nome do Produto', history: 0, mode: defaultResultModes, post: '/produtos/historico' },
  { id: 1, name: 'Estoque Atual de Produtos pelo código ', refine: 1, label: 'Código do Produto', history: 0, mode: defaultResultModes, post: '/produtos/historico' }
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: 'nome',
  controlado: true,
  estoque: -1,
  visao: defaultVisions[0],
  carregado: true
}

const Stocks = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultVisions[0].mode);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [saldos, setSaldos] = useState([]);
  const [openBalance, setOpenBalance] = useState(false);

  const [openRequestDialog, setOpenRequestDialog] = useState(false);

  const [state, setState] = useState(defaultState);

  const [inicio, setInicio] = useState(new Date());
  const [fim, setFim] = useState(new Date());

  const openExportDialog = async (format) => {
    await agm.post('/estoques/export', {
      format: format,
      filtro: filter,
      colunas: defaultResultColumns,
      compartimentos: dependencies.stocks
    }, {}).then(async (response) => {
      setMessage(response.data);
      setOpenAlert(true);
      const link = window.document.createElement('a');
      var filename = 'estoque.xlsx';
      if (format == 'pdf') {
        filename = 'estoque.pdf'
      }
      var url = process.env.REACT_APP_AGM_ENDPPOINT + '/exports/' + filename;
      link.setAttribute('download', filename);
      link.href = url;
      if (format == 'pdf') {
        link.target = filename;
      }
      window.document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: 'Erro ao gerar o arquivo. ' + error.message });
      setOpenAlert(true);
    });
  }

  const openEdition = async (item) => {
    setItem(item);
    await agm.get('/notas/ajuste/' + item.id, { produto: item.id }, {}).then((response) => {
      if (!response.data.error) {
        setDependencies(
          {
            ...dependencies,
            brandings: response.data.marcas,
            providers: response.data.fornecedores,
            units: response.data.unidades,
            applications: response.data.aplicacoes,
            types: response.data.tipos,
            stocks: response.data.estoques
          }
        );
        item.idEstoque = null;
        item.qtdProduto = null;
        item.qtdOrigen = null;
        item.idEstoqueOrigen = null;
        setItem(item);
        setOpenEditionDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const openRequest = (item) => {
    setItem(item);
    agm.get('/notas/dependencias/' + item.id, {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({
          items: response.data.itens,
          removes: [],
          stocks: response.data.estoques,
          technicians: response.data.tecnicos
        });
        item.ordem = response.data.proximaNota.valor;
        item.idProduto = '';
        item.qtdProduto = null;
        item.codigoProduto = '';
        item.nomeProduto = '';
        item.custoProduto = '';
        item.valorMaterial = '';
        item.valorInstalacao = '';
        item.produto = {};
        item.qtd = 0;
        item.estoque = null;
        setItem(item);
        setOpenRequestDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const openCreation = (item) => {
    setItem(item);
    agm.get('/notas/dependencias/' + item.id, {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({
          items: response.data.itens,
          removes: [],
          stocks: response.data.estoques
        });
        item.ordem = response.data.proximaNota.valor;
        item.idProduto = '';
        item.qtdProduto = null;
        item.codigoProduto = '';
        item.nomeProduto = '';
        item.custoProduto = '';
        item.valorMaterial = '';
        item.valorInstalacao = '';
        item.produto = {};
        item.qtd = 0;
        item.estoque = null;
        setItem(item);
        setOpenCreationDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const openDeletion = (item) => {
    setItem(item);
    agm.post('/notas/saldo', { produto: item.id, inicio: inicio, fim: fim }, {}).then((response) => {
      if (!response.data.error) {
        setSaldos(response.data);
        setOpenBalance(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const changeBalanceFilter = async (inicio, fim) => {
    agm.post('/notas/saldo', { produto: item.id, inicio: inicio, fim: fim }, {}).then((response) => {
      if (!response.data.error) {
        setSaldos(response.data);
        setOpenBalance(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const openTreatment = async (item) => {
    setItem(item);
    await agm.get('/notas/ajuste/' + item.id, { produto: item.id }, {}).then((response) => {
      if (!response.data.error) {
        setDependencies(
          {
            ...dependencies,
            brandings: response.data.marcas,
            providers: response.data.fornecedores,
            units: response.data.unidades,
            applications: response.data.aplicacoes,
            types: response.data.tipos,
            stocks: response.data.estoques,
          },
        );
        item.idEstoque = null;
        item.qtdProduto = null;
        item.qtd = null;
        item.qtdDestino = null;
        item.qtdProdutoDestino = null;
        item.idEstoqueDestino = null;
        setItem(item);
        setOpenTreatmentDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeRequest = () => {
    setOpenRequestDialog(false);
  };

  const closeBalance = () => {
    setOpenBalance(false);
  };


  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateTreatmentValues = (values) => {
    setItem(values);
    var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    agm.put('/notas/transferencia/' + values.id, { produto: values, usuario: usuario }).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeTreatment();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const updateValues = (values) => {
    setItem(values);
    var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    agm.put('/notas/ajuste/' + values.id, { produto: values, usuario: usuario }).then((response) => {
      if (!response.data.error) {
        var lanc = response.data.lancamento;
        agm.put('/notas/tratamento/' + lanc.id, {}).then((response) => {
          if (!response.data.error) {
            refreshItems();
            closeEdition();
          }
          setMessage(response.data);
          setOpenAlert(true);
        }).catch((error) => {
          console.error(error);
          setMessage({ error: true, info: true, message: error.message });
          setOpenAlert(true);
        })
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const createValues = (values, items) => {
    var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    var lancamento = {
      id: values.id,
      ordem: values.ordem,
      data: values.data,
      anotacao: values.anotacao,
      fase: values.fase,
      estoque: values.estoque
    };
    agm.post('/notas', { lancamento: lancamento, itens: items, usuario: usuario }).then((response) => {
      if (!response.data.error) {
        var lanc = response.data.lancamento;
        agm.put('/notas/tratamento/' + lanc.id, {}).then((response) => {
          if (!response.data.error) {
            refreshItems();
            closeCreation();
          }
          setMessage(response.data);
          setOpenAlert(true);
        }).catch((error) => {
          console.error(error);
          setMessage({ error: true, info: true, message: error.message });
          setOpenAlert(true);
        })
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const requestValues = (values, items) => {
    var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    var lancamento = {
      id: values.id,
      ordem: values.ordem,
      data: values.data,
      anotacao: values.anotacao,
      fase: values.fase,
      estoque: values.estoque,
      tecnico: values.tecnico
    };
    agm.post('/notas/retirada', { lancamento: lancamento, itens: items, usuario: usuario }).then((response) => {
      if (!response.data.error) {
        var lanc = response.data.lancamento;
        agm.put('/notas/tratamento/' + lanc.id, {}).then((response) => {
          if (!response.data.error) {

            const link = window.document.createElement('a');
            var url = process.env.REACT_APP_AGM_ENDPPOINT + '/reports/REQUISICAO_DE_MATERIAL.pdf';
            link.setAttribute('download', "REQUISICAO_DE_MATERIAL.pdf");
            link.setAttribute('target', '_target');
            link.href = url;
            window.document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);

            refreshItems();
            closeRequest();
          }
          setMessage(response.data);
          setOpenAlert(true);
        }).catch((error) => {
          console.error(error);
          setMessage({ error: true, info: true, message: error.message });
          setOpenAlert(true);
        })
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const deleteValues = (values) => {
    agm.delete('/produtos/' + values.id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };

  const refreshItems = () => {
    agm.post(vision.post, { filtro: filter }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / filter.registros)) + 1,
          page: filter.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
      }
    }).catch((error) => {
      console.error(error);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
    };
    setFilter(value);
    agm.post(vision.post, { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const changeFilter = (vision, keyword, page, rows, startDateTime, endDateTime, stock, qtdLoaded, category) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      estoque: stock,
      controlado: true,
      ativo: true,
      visao: vision,
      ordem: vision.mode[selectedMode].columns[0].sortable,
      ordenacao: 'asc',
      carregado: qtdLoaded,
      categoria: category
    };
    setResultModes(vision.mode);
    setVision(vision);
    setFilter(value);
    agm.post(vision.post, { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  return (
    <Page
      className={classes.root}
      title="Produtos"
    >
      <Container maxWidth={false}>

        <Toolbar
          icon={GiHandTruck}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          openRequest={openRequest}
          changeFilter={changeFilter}
        />

        <Balance
          item={item}
          open={openBalance}
          selectedMode={selectedMode}
          closeBalance={closeBalance}
          dependencies={dependencies}
          changeBalanceFilter={changeBalanceFilter}
          saldos={saldos}
        />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Create item={item}
          open={openCreationDialog}
          closeCreation={closeCreation}
          createValues={createValues}
          dependencies={dependencies}
          selectedMode={selectedMode}
        />

        <Request item={item}
          open={openRequestDialog}
          closeRequest={closeRequest}
          requestValues={requestValues}
          dependencies={dependencies}
          selectedMode={selectedMode}
        />

        <Ajustment item={item}
          open={openEditionDialog}
          closeEdition={closeEdition}
          updateValues={updateValues}
          dependencies={dependencies}
        />

        <Transfer item={item}
          open={openTreatmentDialog}
          closeEdition={closeTreatment}
          updateValues={updateTreatmentValues}
          dependencies={dependencies}
        />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Results
                resultSet={state}
                resultModes={resultModes}
                icon={GiHandTruck}
                vision={vision}
                selectedMode={selectedMode}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
                changeSort={changeSort}
              />
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Page >
  );
};

export default Stocks;
